import { render, staticRenderFns } from "./resourcefolder.vue?vue&type=template&id=62565f39"
import script from "./resourcefolder.vue?vue&type=script&lang=ts"
export * from "./resourcefolder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports